/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { getField, getFieldType } from 'src/azure/services/get-field';
import { supportedOperations } from '../use-field-meet-certain-criteria';

export function useOperatorsHook() {

	const getOperatorOptions = useCallback(async (workItemField: string): Promise<Array<{ label: string; value: any }>> => {
		const field = await getField(workItemField);
		let results: Array<{ label: string; value: string }> = [];

		results.push(
			{ label: 'Is empty', value: 'CustomOperator.IsEmpty' },
			{ label: 'Is not empty', value: 'CustomOperator.IsNotEmpty' },
		);

		if (field) {
			results = field.supportedOperations
				.filter(operatorItem => supportedOperations.includes(operatorItem.referenceName))
				.map((operationItem) => ({ label: operationItem.name, value: operationItem.referenceName }));
				
			
			if (workItemField === 'System.AreaPath' || workItemField === 'System.IterationPath') {
				results.push({ label: 'Under', value: 'AreaPathCustomOperator.Under' });
			}

			const fieldType = getFieldType(field.type);
			if (fieldType === 'DateTime') {
				results.push({ label: 'Before', value: 'DateCustomOperator.Before' });
				results.push({ label: 'After', value: 'DateCustomOperator.After' });
			}

			if (fieldType === 'Html') {
				results.push({ label: 'Contains', value: 'SupportedOperations.Contains' });
			}

			if (
				[
					'Microsoft.VSTS.CMMI.Escalate',
					'Microsoft.VSTS.CMMI.RequirementType',
					'Microsoft.VSTS.CMMI.Committed',
					'Microsoft.VSTS.CMMI.UserAcceptanceTest',
					'Microsoft.VSTS.CMMI.MeetingType',
					'Microsoft.VSTS.CMMI.TaskType',
					'Microsoft.VSTS.CMMI.RequiresReview',
					'Microsoft.VSTS.CMMI.RequiresTest',
					'Microsoft.VSTS.CMMI.RootCause',
					'Microsoft.VSTS.CMMI.Blocked',
					'Microsoft.VSTS.Common.Severity',
					'Microsoft.VSTS.Common.ValueArea',
					'Microsoft.VSTS.Common.Risk',
					'Microsoft.VSTS.Common.ResolvedReason',
					'Microsoft.VSTS.Common.Triage',
					'Microsoft.VSTS.Common.Discipline',
					'Microsoft.VSTS.Build.IntegrationBuild',
					'Microsoft.VSTS.Build.FoundIn',
					'System.Reason',
					'System.WorkItemType',
					'Microsoft.VSTS.Common.Activity',
					'Microsoft.VSTS.Common.Priority',
					'System.BoardColumn',
					'System.State',
					'System.AreaPath',
					'System.IterationPath',
					'System.Tags'
				].includes(workItemField) ||
				fieldType === 'boolean' ||
				field.isPicklist ||
				field.isIdentity
			) {
				results = results.filter(item => item.value !== 'SupportedOperations.Contains');
				results.push({ label: 'In', value: 'SupportedOperations.In' });
				results.push({ label: 'Not in', value: 'SupportedOperations.NotIn' });
			}
		}

		results.push(
			{ label: 'Is empty', value: 'CustomOperator.IsEmpty' },
			{ label: 'Is not empty', value: 'CustomOperator.IsNotEmpty' },
		);

		return results;
	}, []);

	return {
		getOperatorOptions,
	};
}